import { render, staticRenderFns } from "./My.vue?vue&type=template&id=3fd8be33&scoped=true&"
import script from "./My.vue?vue&type=script&lang=js&"
export * from "./My.vue?vue&type=script&lang=js&"
import style0 from "./My.vue?vue&type=style&index=0&id=3fd8be33&prod&lang=css&"
import style1 from "./My.vue?vue&type=style&index=1&id=3fd8be33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd8be33",
  null
  
)

export default component.exports